'use client';

import { PageActions } from '@/types';
import { createContext, useContext, ReactNode } from 'react';

interface PageActionsContextType {
  pageActions: PageActions[];
  user: {
    id: any;
    role: string | null;
  };
}

const PageActionsContext = createContext<PageActionsContextType | undefined>(undefined);

export function PageActionsProvider({ 
  children, 
  pageActions,
  user
}: { 
  children: ReactNode;
  pageActions: PageActions[];
  user: {
    id: any;
    role: string | null;
  };
}) {
  return (
    <PageActionsContext.Provider value={{ pageActions, user }}>
      {children}
    </PageActionsContext.Provider>
  );
}

export function usePageActions() {
  const context = useContext(PageActionsContext);
  if (context === undefined) {
    throw new Error('usePageActions must be used within a PageActionsProvider');
  }
  return context;
} 